import { render, staticRenderFns } from "./CoreFilePicker.vue?vue&type=template&id=25dbeb10&scoped=true&"
import script from "./CoreFilePicker.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CoreFilePicker.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CoreFilePicker.vue?vue&type=style&index=0&id=25dbeb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dbeb10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dbeb10')) {
      api.createRecord('25dbeb10', component.options)
    } else {
      api.reload('25dbeb10', component.options)
    }
    module.hot.accept("./CoreFilePicker.vue?vue&type=template&id=25dbeb10&scoped=true&", function () {
      api.rerender('25dbeb10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreFilePicker/CoreFilePicker.vue"
export default component.exports